import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import { Link, Breadcrumbs } from "@material-ui/core";
import jQuery from "jquery";
import "datatables.net-bs4";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-buttons/js/buttons.flash";
import "pdfmake/build/vfs_fonts";
import "pdfmake/build/pdfmake";

import AutoComplete from "components/ui/autocomplete/AutoComplete";
import Btn from "components/ui/button/Btn";

import {
  NOTIFY,
  ALERTS,
  REPORT_NAMES,
  REPORT_DESCRIPTION,
  DEFAULTS,
  LABELS,
} from "common/consts";
import { commonJs } from "common/common";
import { COMMON_ACTIONS } from "actions/CommonActions";
import { REPORT_ACTIONS } from "actions/ReportActions";
import { API_Reports } from "apihandler/Reports/pooja";
import { API_Map } from "apihandler/Map";
import { API_UserLogin } from "apihandler/UserLogin";

var $ = jQuery;

class ProximityReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicles: [],
      zones: [],
      selectedVehicles: {},
      selectedZone: {},
      selectedRange: {},
    };
  }

  componentDidMount() {
    document.getElementById("root").classList.remove("login");
    document.getElementById("root").classList.add("scroll");
    this.getInitialData();
    this.getZoneDetails();
  }

  getInitialData = () => {
    const args = {};
    let self = this;
    args.pageNo = 0;
    args.pageLength = 100000;
    args.orderBy = "ASC";
    args.sortColumn = "";
    API_UserLogin.setToken(localStorage.token);
    API_Map.getAllVehicles(args)
      .then((res) => {
        self.props.setVehicles({
          vehicles: res,
        });
        self.props.setLoading({
          loading: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getZoneDetails = () => {
    const args = {};
    let self = this;
    args.pageNo = 0;
    args.pageLength = 100000;
    args.orderBy = "ASC";
    args.sortColumn = "";
    API_Map.getAllZones(args)
      .then((res) => {
        if (res.Result === 200) {
          self.setState({
            zones: res.Response,
          });
        }
        self.props.setLoading({
          loading: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onChangeVechicle = (vehicle) => {
    this.setState({
      selectedVehicles: vehicle,
    });
  };

  onChangeZone = (zone) => {
    if (!zone) {
      zone = {};
    }
    this.setState({
      selectedZone: zone,
    });
  };

  onChangeRange = (val) => {
    this.setState({ selectedRange: val });
  };

  loadReport = () => {
    const { selectedVehicles, selectedZone, selectedRange } = this.state;
    let self = this;
    if (!selectedVehicles.id) {
      commonJs.showNotify(
        this.props,
        NOTIFY.WARNING,
        ALERTS.PLEASE_SELECT_VEHICLE,
        commonJs.getDefaultDismissBtn()
      );
      return;
    }
    if (!selectedZone.id) {
      commonJs.showNotify(
        this.props,
        NOTIFY.WARNING,
        ALERTS.PLEASE_SELECT_ZONE,
        commonJs.getDefaultDismissBtn()
      );
      return;
    }
    if (!selectedRange.id) {
      commonJs.showNotify(
        this.props,
        NOTIFY.WARNING,
        ALERTS.PLEASE_SELECT_RANGE,
        commonJs.getDefaultDismissBtn()
      );
      return;
    }

    this.props.setLoading({
      loading: true,
    });

    let args = {
      imei: selectedVehicles.id,
      zone: selectedZone.id,
      range: selectedRange.id, // > 10 Kms
    };

    API_Reports.getProximityReport(args)
      .then((res) => {
        self.props.setLoading({
          loading: false,
        });
        if (res.Result === 200) {
          const { cols, rows } = res.Response;
          let columns = [];
          for (var c = 0; c < cols.length; c++) {
            columns.push({
              title: cols[c],
            });
          }

          if ($.fn.dataTable.isDataTable("#reportGrid")) {
            let table = $("#reportGrid").DataTable();
            table.destroy();
          }
          $("#reportGrid").empty();

          let title = REPORT_NAMES.PROXIMITY_REPORT;

          $("#reportGrid").DataTable({
            dom: "Bfrtip",
            buttons: [
              {
                extend: "copy",
                className: "reportBtn",
                title: title,
              },
              {
                extend: "pdf",
                className: "reportBtn",
                title: title,
              },
              {
                extend: "excel",
                className: "reportBtn",
                title: title,
              },
              {
                extend: "csv",
                className: "reportBtn",
                title: title,
                text: "CSV",
              },
              {
                extend: "print",
                className: "reportBtn",
                title: title,
                customize: function (win) {
                  commonJs.getExportPrintCss(win);
                },
              },
            ],
            paging: false,
            scrollY: DEFAULTS.REPORT_GRID_HEIGHT,
            columns: columns,
            data: rows,
          });
        }
      })
      .catch((err) => {
        console.log("getDailyTravel: err:", err);
      });
  };

  render() {
    const { vehicles, selectedVehicles, selectedZone, zones } = this.state;
    const { vehiclesList } = this.props.commonReducer;

    for (var i = 0; i < vehiclesList.length; i++) {
      vehicles.push({ id: vehiclesList[i].imei, name: vehiclesList[i].name });
    }

    let options = [];
    for (let i = 1; i < 100; i++) {
      options.push({
        id: i,
        name: "< " + i + " Kms",
      });
    }

    return (
      <div className="reportPageWrapper height100">
        <Breadcrumbs aria-label="breadcrumb" className="breadcrumb">
          <Link color="inherit" href="/">
            Home
          </Link>
          <p>{REPORT_NAMES.PROXIMITY_REPORT}</p>
        </Breadcrumbs>
        <p className="reportDescription">
          {REPORT_DESCRIPTION.PROXIMITY_REPORT}
        </p>
        <div className="reportFilters">
          <div
            className="width20"
            style={{ marginTop: 10, marginBottom: 10, paddingLeft: 0 }}
          >
            <AutoComplete
              label={LABELS.SELECT_VEHICLES}
              list={vehicles}
              onChange={this.onChangeVechicle}
              defaultValue={selectedVehicles}
              multiple={false}
              size="small"
            />
          </div>
          <div
            className="width20"
            style={{ marginTop: 10, marginBottom: 10, paddingLeft: 20 }}
          >
            <AutoComplete
              label={LABELS.ZONE}
              list={zones}
              onChange={this.onChangeZone}
              defaultValue={selectedZone}
              multiple={false}
              size="small"
            />
          </div>
          <div
            className="width20"
            style={{ marginTop: 10, marginBottom: 10, paddingLeft: 20 }}
          >
            <AutoComplete
              label={LABELS.RANGE}
              list={options}
              onChange={this.onChangeRange}
              multiple={false}
              size="small"
            />
          </div>

          <div className="width10" style={{ paddingLeft: 20 }}>
            <Btn onClick={this.loadReport} className="primaryBtn">
              Submit
            </Btn>
          </div>
        </div>
        <div className="reportGridWrapper">
          <table
            id="reportGrid"
            className="mdl-data-table width100"
            cellSpacing="0"
            cellPadding="3"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    commonReducer: state.commonReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setVehicles: (values) => {
      dispatch({
        type: COMMON_ACTIONS.SET_VEHICLES,
        values,
      });
    },
    setLoading: (values) => {
      dispatch({
        type: REPORT_ACTIONS.SET_LOADING,
        values,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(ProximityReport));
